
import { Component, Vue } from "vue-property-decorator";
import BackgroundLoader from "@/components/Common/BackgroundLoader.vue";

@Component({
  components: {
    BackgroundLoader,
  }
})
export default class EquipoPrevencion extends Vue {

  public frame_prevencion = "1_2_2_equipo_gest_prev.svg";
  public texto =
    `Nuestros profesionales reciben de manera continua formación en materia de Prevención de Riesgos Laborales, actualizada a los nuevos procedimientos de ejecución y aprovechando los avances en cuanto a medidas de protección colectivas e individuales que nos ofrece el mercado.
            <br/><br/>
            Esta formación es impartida por nuestro servicio de Prevención constituido por técnicos especializados que, desde la fase de estudio, se integran en el equipo de Gestión de Obra, elaborando los correspondientes Planes de Seguridad y Salud, comprobando que planificación de obra y presupuesto de seguridad y salud son los idóneos para garantizar una ejecución de obra segura.`;
}

